module.exports = __webpack_public_path__ + "static/media/WGIPhoto.63adfcb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/avtar/WGIPhoto.jpg
// module id = 52
// module chunks = 0